module.exports = __webpack_public_path__ + "static/media/navReviewedActive.e9c0a587.svg";